import React from 'react'
import QuestionCard from './QuestionCard'
import RadioOption from './RadioOption'

interface SectionProps {
  formData: Record<string, any>
  updateField: (field: string, value: any) => void
}

/**
 * Section E: Culture (Q15-Q17)
 *
 * Explores the team's relationship with AI, recent experimentation,
 * and the biggest challenges in adopting AI in operations.
 */
const SectionE: React.FC<SectionProps> = ({ formData, updateField }) => {
  return (
    <div className="flex flex-col gap-6">

      {/* Q15 */}
      <QuestionCard
        title="Como você descreveria a relação da sua equipe com IA?"
        required
      >
        <RadioOption
          name="q15"
          value="entusiasta"
          label="Entusiasta — a equipe busca ativamente novas formas de usar"
          selected={formData.q15 === 'entusiasta'}
          onChange={(value) => updateField('q15', value)}
        />
        <RadioOption
          name="q15"
          value="receptiva"
          label="Receptiva — usam quando alguém sugere"
          selected={formData.q15 === 'receptiva'}
          onChange={(value) => updateField('q15', value)}
        />
        <RadioOption
          name="q15"
          value="indiferente"
          label="Indiferente — não gera muito interesse"
          selected={formData.q15 === 'indiferente'}
          onChange={(value) => updateField('q15', value)}
        />
        <RadioOption
          name="q15"
          value="resistente"
          label="Resistente — há desconforto ou medo"
          selected={formData.q15 === 'resistente'}
          onChange={(value) => updateField('q15', value)}
        />
      </QuestionCard>

      {/* Q16 */}
      <QuestionCard
        title="Nos últimos 6 meses, você testou algum novo uso de IA que não existia antes na operação?"
        required
      >
        <RadioOption
          name="q16"
          value="3_mais_coisas"
          label="Sim, testamos 3+ coisas novas"
          selected={formData.q16 === '3_mais_coisas'}
          onChange={(value) => updateField('q16', value)}
        />
        <RadioOption
          name="q16"
          value="1_2_coisas"
          label="Sim, testamos 1-2 coisas novas"
          selected={formData.q16 === '1_2_coisas'}
          onChange={(value) => updateField('q16', value)}
        />
        <RadioOption
          name="q16"
          value="nada_novo"
          label="Não testamos nada novo"
          selected={formData.q16 === 'nada_novo'}
          onChange={(value) => updateField('q16', value)}
        />
        <RadioOption
          name="q16"
          value="usando_menos"
          label="Estamos usando menos IA do que antes"
          selected={formData.q16 === 'usando_menos'}
          onChange={(value) => updateField('q16', value)}
        />
      </QuestionCard>

      {/* Q17 */}
      <QuestionCard
        title="Qual o maior desafio que você enfrenta ao usar IA na operação?"
        required
      >
        <RadioOption
          name="q17"
          value="qualidade_resultados"
          label="Qualidade dos resultados (IA erra muito / resultados genéricos)"
          selected={formData.q17 === 'qualidade_resultados'}
          onChange={(value) => updateField('q17', value)}
        />
        <RadioOption
          name="q17"
          value="integracao_sistemas"
          label="Integração com sistemas existentes"
          selected={formData.q17 === 'integracao_sistemas'}
          onChange={(value) => updateField('q17', value)}
        />
        <RadioOption
          name="q17"
          value="falta_conhecimento"
          label="Falta de conhecimento / capacitação da equipe"
          selected={formData.q17 === 'falta_conhecimento'}
          onChange={(value) => updateField('q17', value)}
        />
        <RadioOption
          name="q17"
          value="definir_valor"
          label="Definir onde IA realmente agrega valor"
          selected={formData.q17 === 'definir_valor'}
          onChange={(value) => updateField('q17', value)}
        />
        <RadioOption
          name="q17"
          value="escalar_uso"
          label="Escalar o uso além de experimentos pontuais"
          selected={formData.q17 === 'escalar_uso'}
          onChange={(value) => updateField('q17', value)}
        />
        <RadioOption
          name="q17"
          value="medir_roi"
          label="Medir ROI"
          selected={formData.q17 === 'medir_roi'}
          onChange={(value) => updateField('q17', value)}
        />
        <RadioOption
          name="q17"
          value="outro"
          label="Outro"
          selected={formData.q17 === 'outro'}
          onChange={(value) => updateField('q17', value)}
          hasOtherField
          otherValue={formData.q17_other ?? ''}
          onOtherChange={(value) => updateField('q17_other', value)}
        />
      </QuestionCard>
    </div>
  )
}

export default SectionE
